<div [class]="theme$ | async">
  <div [@routeAnimations]="routeAnimationState">
    <router-outlet (activate)="onRouteActivate()"></router-outlet>
  </div>
  <!-- -->
</div>
